import { CLAIM_STATUS } from "../constants";
import type { Claim, ClaimTranslator, NextSteps } from "../types";
import { isAwaitingCustomerReply, isAwaitingReview } from "./claimState";

export const getCustomerNextSteps = (
  claim: Claim,
  t: ClaimTranslator,
): NextSteps | null => {
  if (isAwaitingCustomerReply(claim)) {
    return {
      title: t("status.nextSteps.reviewTitle"),
      body: t("status.nextSteps.replyBody"),
      timeframe: null,
      actionRequired: true,
      showNoActionBadge: false,
    };
  }

  if (isAwaitingReview(claim)) {
    return {
      title: t("status.nextSteps.reviewTitle"),
      body: t("status.nextSteps.reviewBody"),
      timeframe: t("status.nextSteps.timeframe"),
      actionRequired: false,
      showNoActionBadge: true,
    };
  }

  if (claim.claim_status === CLAIM_STATUS.DENIED) {
    return {
      title: t("status.nextSteps.deniedTitle"),
      body: t("status.nextSteps.deniedBody"),
      timeframe: null,
      actionRequired: false,
      showNoActionBadge: false,
    };
  }

  return null;
};
